export enum ModalStep {
  COST_MANUFACTURER = 'costManufacturer',
  COLUMNS_HEADERS = 'columnsHeaders',
  PREVIEW_ROWS = 'previewRows',
  UNKOWN_MANUFATURERS = 'unkownManufacturers',
}
